module.exports = __webpack_public_path__ + "img/8ne.aeee0347.svg";